module.exports = __webpack_public_path__ + "img/27.caaea3fa.jpg";